import React from 'react';
import { Row, Grid, Text } from '@custom-components';
import { StyledInfoContainer, StyledContainer } from '../Steps.styles';

function NoExtraConfiguration() {
  return (
    <StyledInfoContainer>
      <StyledContainer>
        <Row>
          <Grid.Col lg={12}>
            <Text.CopyParagraph>This Connection does not need any extra configuration attributes.</Text.CopyParagraph>
          </Grid.Col>
        </Row>
      </StyledContainer>
    </StyledInfoContainer>
  );
}

export default NoExtraConfiguration;
